import React from 'react';

interface ITPartnerConfigurationProps {
    configuration: {
        Login?: string;
        Password?: string;
        Warehouses?: string;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface ITPartnerConfigurationComponent extends React.FC<ITPartnerConfigurationProps> {
    configFields: string[];
}

const ITPartnerConfiguration: ITPartnerConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">�</span>
                    Логин
                </label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={configuration.Login || ''}
                        onChange={(e) => onChange('Login', e.target.value)}
                        placeholder="Введите логин"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🔒</span>
                    Пароль
                </label>
                <div className="input-group-custom">
                    <input
                        type="password"
                        className="form-input-custom"
                        value={configuration.Password || ''}
                        onChange={(e) => onChange('Password', e.target.value)}
                        placeholder="Введите пароль"
                        disabled={disabled}
                        autoComplete='new-password'
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
ITPartnerConfiguration.configFields = ['Login', 'Password'];

export default ITPartnerConfiguration;
